import { injectable } from 'tsyringe';
import { CryptoCoin } from '../../types';
import { parseCryptoSymbol } from '../../utils';
import { QuoteApi } from '../QuoteApi';
import { availableCoins } from './cryptoLookups';
import { AXOS_COIN } from './lookups';

@injectable()
export class AxosQuoteApi extends QuoteApi {
    override getStablecoin(): Promise<CryptoCoin | null> {
        return Promise.resolve<CryptoCoin>({
            name: 'Axos Stablecoin',
            symbol: AXOS_COIN,
        });
    }

    override getAvailableCoin(): Promise<CryptoCoin[]> {
        return Promise.resolve<CryptoCoin[]>(Object.values(availableCoins));
    }

    override getCoin(symbol: string): Promise<CryptoCoin | null> {
        const { base } = parseCryptoSymbol(symbol);
        return Promise.resolve(availableCoins[base] || null);
    }
}
